import { Component, OnInit, Input } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable, Subject } from 'rxjs';
import { PlayerStat, GoalieStat } from '../../models/stats';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.css', './../../base/base-table/base-table.component.css']
})
export class StatsComponent implements OnInit {
  stats: Observable<any[]>;
  nhlStats: any;
  statType: string = "Regular";
  @Input('playerId') playerId;
  @Input('isGoalie') isGoalie;

  constructor(private firestore: AngularFirestore, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.getData();
  }

  ngOnChanges() {
    this.getData();
  }

  getData() {
    if(this.isGoalie) {
      this.stats = this.firestore.collection('statsG', ref => ref.where('ID', '==', this.playerId).where('Type', '==', this.statType).orderBy('Season', 'asc')).valueChanges();

      let goalieStat = new GoalieStat();
      let i = 0;
      this.stats.subscribe(stats => {
        stats.forEach(stat => {
          if(stat.League == "NHL") {
            i++;
            goalieStat.add(stat);
          }
        });
        goalieStat.gaa = this.roundTo(goalieStat.gaa / i, 2);
        goalieStat.sv = this.roundTo(goalieStat.sv / i, 2);
        goalieStat.avr = this.roundTo(goalieStat.avr / i, 2);
        this.nhlStats = goalieStat;
      });
    }
    else {
      this.stats = this.firestore.collection('stats', ref => ref.where('ID', '==', this.playerId).where('Type', '==', this.statType).orderBy('Season', 'asc')).valueChanges();

      let playerStat = new PlayerStat();
      let i = 0;
      this.stats.subscribe(stats => {
        stats.forEach(stat => {
          if(stat.League == "NHL") {
            i++;
            playerStat.add(stat);
          }
        });
        playerStat.p = playerStat.g + playerStat.a;
        playerStat.s = this.roundTo(playerStat.s / i, 2);
        playerStat.fo = this.roundTo(playerStat.fo / i, 2);
        playerStat.avr = this.roundTo(playerStat.avr / i, 2);
        playerStat.atoi = this.getTime(playerStat.totalToi, i);
        this.nhlStats = playerStat;
      });
    }
  }

  updateStats(event) {
    this.statType = event.target.value;
    this.getData();
  }

  roundTo(num: number, places: number) {
    if(num == 0) return 0;
    else {
      const factor = 10 ** places;
      return Math.round(num * factor) / factor;
    }
  }

  getTime(num: number, seasons: number): string {
    let n = Math.floor(num / seasons);
    let secs: string = (n % 60).toString();
    let mins: string = (Math.floor(n / 60)).toString();
    return mins.padStart(2, '0') + ":" + secs.padStart(2, '0');
  }

}
